import { createSelector } from 'reselect';
import getPropFromModule from './getPropFromModule';
import { HIDE_NOTES, IS_FETCHING_VENDOR_CONFIG_NOTES } from '../model';

export const getIsFetchingVendorConfig = state =>
  getPropFromModule(state, IS_FETCHING_VENDOR_CONFIG_NOTES);

export const getIsHideNotes = state => getPropFromModule(state, HIDE_NOTES);

export const getShowNotes = createSelector(
  getIsFetchingVendorConfig,
  getIsHideNotes,
  (isFetchingVendorConfig, hideNotes) => !isFetchingVendorConfig && !hideNotes,
);
